/* eslint-disable react/prop-types */
import React, { Component } from 'react';
import {
  selectBalanceAdsAccount,
  selectBalanceMainAccount,
  selectTotalBalance
} from 'mt-react-common/modules/userFlowFunds/common/reducers/state/authAccountBalance';
import { connect } from 'react-redux';
import { NavLink } from 'react-router-dom';
import { t } from 'utils/translates';

// eslint-disable-next-line react/prefer-stateless-function
class BalancesBlocks extends Component {
  render() {
    return (
      <React.Fragment>
        <div className="row">
          <div className="col-xs-24 col-sm-12">
            <div className="panel panel-success panel-footer_bg-sub text-center">
              <div className="panel-body">
                <div className="media media_inline-table media_widget">
                  <div className="avatar-lg media-left">
                    <div className="avatar avatar-icon avatar-icon-lg avatar-icon-success">
                      <i className="fa fa-2x fa-briefcase" />
                    </div>
                  </div>
                  <div className="media-body media-middle">
                    <div
                      className="media_widget-val"
                      title={`${this.props.balanceAdsAccount.sum} р.`}
                    >
                      {this.props.balanceAdsAccount.sum}
                      <i className="fa fa-rub font-size-h3" />
                    </div>
                    <div className="media_widget-title text-success">
                      {t('Рекламный баланс')}
                    </div>
                  </div>
                </div>
              </div>
              <NavLink
                to="/main/my-balance/pay/payment"
                className="panel-footer text-center text-muted"
              >
                {t('Пополнить')}
              </NavLink>
            </div>
          </div>
          <div className="col-xs-24 col-sm-12">
            <div className="panel panel-primary panel-footer_bg-sub text-center">
              <div className="panel-body">
                <div className="media media_inline-table media_widget">
                  <div className="media-left avatar-lg">
                    <div className="avatar avatar-icon avatar-icon-lg avatar-icon-primary">
                      <i className="fa fa-money fa-2x" />
                    </div>
                  </div>
                  <div className="media-body media-middle">
                    <div
                      className="media_widget-val"
                      title={`${this.props.balanceMainAccount.sum} р.`}
                    >
                      {this.props.balanceMainAccount.sum}
                      <i className="fa fa-rub font-size-h3" />
                    </div>
                    <div className="media_widget-title text-primary">
                      {t('Основной баланс (заработано)')}
                    </div>
                  </div>
                </div>
              </div>
              <NavLink
                to="/main/my-balance/payout"
                className="panel-footer text-center text-muted"
              >
                {t('Вывести средства')}
              </NavLink>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => ({
  balanceMainAccount: selectBalanceMainAccount(state),
  balanceAdsAccount: selectBalanceAdsAccount(state),
  totalBalance: selectTotalBalance(state)
});

export default connect(mapStateToProps)(BalancesBlocks);



// WEBPACK FOOTER //
// ./src/components/UserFlowFunds/BalancesBlocks/BalancesBlocks.js